import React, { useState } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  CardHeader,
} from "@material-ui/core/";
import { deepOrange } from "@material-ui/core/colors";
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";
import LinearProgress from "@material-ui/core/LinearProgress";
import SpeedIcon from "@material-ui/icons/Speed";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import Tooltip from "@material-ui/core/Tooltip";
import Audits from "./../Assets/audits.png";
import Location from "./../Assets/LOCATIONS.png";
import AuditNames from "./../Assets/AUDIT_NAME.png";
import Auditor from "./../Assets/auditor.png";
import { Chart as GoogleChart } from "react-google-charts";
import TimelineIcon from "@material-ui/icons/Timeline";
import Spinner from "./../../../Global/Spinner";
import Chart  from "react-apexcharts";
import moment from "moment";
import '../../../index.css'
import Colors from '../../../Global/colors'
import analysisIcon from "./../Assets/analysis.png";
import searchIcon from "./../Assets/search.png";
import statusIcon from "./../Assets/status.png";
import {useTranslation} from 'react-i18next'
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({    
  root: {
    flexGrow: 1,

    marginTop:'20px'
  },
  root2: {
    flexGrow: 1,
    padding: theme.spacing(1),
  },
  card: {
    maxWidth: 345,
  },
  title: {
    fontSize: 19,
  },
  chartOneTitle: {
    fontSize: 11,
    fontWeight: "bold",
    color: "white",
    textAlign: "center",
    marginBottom: 5,
    // paddingBottom:10
  },
  iconColor: {
    color: deepOrange["300"],
    fontSize: 18,
    marginTop: 10,
  },
  button: {
    padding: 0,
    paddingLeft: 12,
  },
  header: {
    padding: 0,
    paddingLeft: 0,
  },
}));

const BorderLinearProgressofHighest = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 10,
  },
  colorPrimary: {
    backgroundColor:
      theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: "#1a90ff",
  },
}))(LinearProgress);

const BorderLinearProgressofHigh = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 10,
  },
  colorPrimary: {
    backgroundColor:
      theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: "#06a05d",
  },
}))(LinearProgress);
const BorderLinearProgressofMedium = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 10,
  },
  colorPrimary: {
    backgroundColor:
      theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: "#ff8b26",
  },
}))(LinearProgress);
const BorderLinearProgressofLow = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 10,
  },
  colorPrimary: {
    backgroundColor:
      theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
  },
  bar: {
    borderRadius: 5,
    backgroundColor: "#ee1717",
  },
}))(LinearProgress);

export const FirstCard = ({
  handleAuditClick,
  dataGlobal,
  handleLocationClick,
  handleNameClick,
  handleAuditorClick,
  barChartData,
  dateChart,
  filterByDateChart,
  setTableFilterOption,
  tableData,
  toggletable,
}) => {
  const {t} = useTranslation()
  const language = useSelector(state => state.languageReducer.language)
  const classes = useStyles();
  const [lineOptions,setLineOption]= React.useState({})
  const [lineSeries,setSeries]=React.useState([])
  const [mixedChartOptions,setMixedChartOptions]= React.useState({
    chart: {
    id: "basic-bar",
    toolbar: {
      show: false
     }}
    })
  const [mixedSeries,setMixedSeries]=React.useState([{name:'',type:'line',data:[]},{name:'',type:'column',data:[]}])
  const [dateData,setDateData]=React.useState(dateChart)
  const [barData,setBarData]=React.useState(barChartData)
  const [radialOptionsInProgress]= React.useState({
    plotOptions: {
      radialBar: {
        startAngle: -135,
        endAngle: 225,
        offsetY:-18,
        hollow: {
          margin: 10,
          size: "60%",
          background: "#043077",
          image: undefined,
          imageOffsetX: 0,
          imageOffsetY: 0,
          position: "front",
          dropShadow: {
            enabled: true,
            top: 3,
            left: 0,
            blur: 4,
            opacity: 0.24
          }
        },
        track: {
          background: "#fff",
          strokeWidth: "67%",
          margin: 0, // margin is in pixels
          dropShadow: {
            enabled: true,
            top: 0,
            left: 0,
            blur: 3,
            opacity: 0.35
          }
        },

        dataLabels: {
          showOn: "always",
          name: {
            offsetY: -5,
            show: true,
            color: "#FFF",
            fontSize: "10px"
          },
          value: {
            formatter: function (val) {
              return  val + '%';
            },
            offsetY: 0,
            color: "#FFF",
            fontSize: "15px",
            show: true
          }
        }
      }
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.9,
        inverseColors: true,
        colorStops: [
          {
            offset: 0,
            color: "#01defe",
            opacity: 1
          },
          {
            offset: 20,
            color: "#1459f3",
            opacity: 1
          },
          // {
          //   offset: 60,
          //   color: "#3dcfff",
          //   opacity: 1
          // },
          // {
          //   offset: 100,
          //   color: "#19123e",
          //   opacity: 1
          // }
        ]
      }
    },
    stroke: {
      lineCap: "round"
    },
    labels: [language == "ar" ? "قيد التقدم" : "In progress"],
    })
   const [seriesInProgress,setSeriesInprogress]=React.useState([0])
   const [radialOptionsSubmitted]= React.useState({

    plotOptions: {
      radialBar: {
        startAngle: -135,
        endAngle: 225,
        offsetY:-18,
        hollow: {
          margin: 10,
          size: "60%",
          background: "#043077",
          image: undefined,
          imageOffsetX: 0,
          imageOffsetY: 0,
          position: "front",
          dropShadow: {
            enabled: true,
            top: 3,
            left: 0,
            blur: 4,
            opacity: 0.24
          }
        },
        track: {
          background: "#fff",
          strokeWidth: "67%",
          margin: 0, // margin is in pixels
          dropShadow: {
            enabled: true,
            top: 0,
            left: 0,
            blur: 3,
            opacity: 0.35
          }
        },

        dataLabels: {
          showOn: "always",
          name: {
            offsetY: -5,
            show: true,
            color: "#FFF",
            fontSize: "10px"
          },
          value: {
            formatter: function (val) {
              return  val + '%';
            },
            offsetY: 0,
            color: "#FFF",
            fontSize: "15px",
            show: true
          }
        }
      }
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.9,
        inverseColors: true,
        colorStops: [
          {
            offset: 0,
            color: "#01defe",
            opacity: 1
          },
          {
            offset: 20,
            color: "#1459f3",
            opacity: 1
          },
        ]
      }
    },
    stroke: {
      lineCap: "round"
    },
    labels: [language == "ar" ? "تقديم" : "Submitted"]
    })
   const [seriesSubmitted,setSeriesSubmitted]=React.useState([0])
   const [radialOptionsApproved]= React.useState({
    plotOptions: {
      radialBar: {
        startAngle: -135,
        endAngle: 225,
        offsetY:-20,
        hollow: {
          margin: 10,
          size: "60%",
          background: "#043077",
          image: undefined,
          imageOffsetX: 0,
          imageOffsetY: 0,
          position: "front",
          dropShadow: {
            enabled: true,
            top: 3,
            left: 0,
            blur: 4,
            opacity: 0.24
          }
        },
        track: {
          background: "#fff",
          strokeWidth: "67%",
          margin: 0, // margin is in pixels
          dropShadow: {
            enabled: true,
            top: 0,
            left: 0,
            blur: 3,
            opacity: 0.35
          }
        },

        dataLabels: {
          showOn: "always",
          name: {
            offsetY: -5,
            show: true,
            color: "#FFF",
            fontSize: "10px"
          },
          value: {
            formatter: function (val) {
              return  val + '%';
            },
            offsetY: 0,
            color: "#FFF",
            fontSize: "15px",
            show: true
          }
        }
      }
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.9,
        inverseColors: true,
        colorStops: [
          {
            offset: 0,
            color: "#01defe",
            opacity: 1
          },
          {
            offset: 20,
            color: "#1459f3",
            opacity: 1
          },
        ]
      }
    },
    stroke: {
      lineCap: "round"
    },
    labels: [ language == "ar" ? "وافق" : "Approved"]
    })
   const [seriesApproved,setSeriesApproved]=React.useState([0])
   const [radialOptionsRejected]= React.useState({
    plotOptions: {
      radialBar: {
        startAngle: -135,
        endAngle: 225,
        offsetY:-20,
        hollow: {
          margin: 10,
          size: "60%",
          background: "#043077",
          image: undefined,
          imageOffsetX: 0,
          imageOffsetY: 0,
          position: "front",
          dropShadow: {
            enabled: true,
            top: 3,
            left: 0,
            blur: 4,
            opacity: 0.24
          }
        },
        track: {
          background: "#fff",
          strokeWidth: "67%",
          margin: 0, // margin is in pixels
          dropShadow: {
            enabled: true,
            top: 0,
            left: 0,
            blur: 3,
            opacity: 0.35
          }
        },

        dataLabels: {
          showOn: "always",
          name: {
            offsetY: -5,
            show: true,
            color: "#FFF",
            fontSize: "10px"
          },
          value: {
            formatter: function (val) {
              return  val + '%';
            },
            offsetY: 0,
            color: "#FFF",
            fontSize: "15px",
            show: true
          }
        }
      }
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.9,
        inverseColors: true,
        colorStops: [
          {
            offset: 0,
            color: "#01defe",
            opacity: 1
          },
          {
            offset: 20,
            color: "#1459f3",
            opacity: 1
          },
        ]
      }
    },
    stroke: {
      lineCap: "round"
    },
    labels: [language == "ar" ? "مرفوض" : "Rejected"]
    })
   const [seriesRejected,setSeriesRejected]=React.useState([0])
  React.useEffect(()=>{
    if(dateData !== dateChart || barData!==barChartData)
    {
    let data=[]
    let category=[]
    dateChart.map(item=>{
      data.push(item[1])
      category.push( moment(item[0]).format("MMM DD"))
    })
    var dataSet=[{
      name:"Data",
      data:data
    }]
    let option={
     chart: {
      height: 380,
      type: "line",
      foreColor: '#6D6D6D',
      events: {
        markerClick: function(event, chartContext, { seriesIndex, dataPointIndex, config}) {
            //console.log(chartContext.w.config.series[0].data[dataPointIndex])
            //console.log(chartContext.w.globals.categoryLabels[dataPointIndex])
            filterByDateChart(dateChart[dataPointIndex][0])
          }
        }
    },
    markers: {
      size: 4,
      colors: ["#098af7"],
      strokeColors: "#fff",
      strokeWidth: 2,
      hover: {
        size: 7
      }
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.9,
        colorStops: [
          {
            offset: 0,
            color: "#01defe",
            opacity: 1
          },
          {
            offset: 20,
            color: "#1459f3",
            opacity: 1
          },
        ]
      }
    },
    grid: {
       borderColor: '#6D6D6D'
    },
    xaxis: {
      categories:category,
      tooltip: {
        enabled: false,
      }
    },
    
    tooltip: {
      enabled: true,
      fillSeriesColor: false,
      marker: {
        show: true,
       },
       custom: function({series, seriesIndex, dataPointIndex, w}) {
        return '<div class="arrow_box">' +
          '<span> <b> Inspection Count: </b>' + series[seriesIndex][dataPointIndex] + '</span>' +
          '</div>'
      }
    },
    
    
   }
    setLineOption(option)
    setSeries(dataSet)
    setDateData(dateChart)
    setBarData(barChartData)
    
   
    if(barChartData.length > 0){
        let series=[]
        let categories=[]
        for(let i=1;i< barChartData.length;i++){
            series.push(Math.round(barChartData[i][1],2))
            categories.push(barChartData[i][0])
        }
        var dataSetSeries=[
          {
          name:"Score",
          type:"line",
          data:series
          },
          {
            name:"Score",
            type:"column",
            data:series
          }
       ]
       let mixedSeriesOptions={
        chart: {
          id: "basic-bar",
          toolbar: {
            show: true
          },
          events: {
            click: function(event, chartContext, { seriesIndex, dataPointIndex, config}) {
                //filterByDateChart(dateChart[dataPointIndex][0])
                setTableFilterOption("");
                toggletable(dataPointIndex, 1);
                //alert(dataPointIndex)
              }
            }
        },
        legend: {
          show: false,
        },
        tooltip: {
          enabled: true,
          fillSeriesColor: false,
          marker: {
            show: true,
           },
           custom: function({series, seriesIndex, dataPointIndex, w}) {
            return '<div class="arrow_box">' +
              '<span> <b> Score </b>' + series[seriesIndex][dataPointIndex] + '</span>' +
              '</div>'
          }
        },
       
        plotOptions: {
          bar: {
            columnWidth: "50%",
          }
        },
        stroke: {
          width: [4, 0, 0]
        },
        xaxis: {
          categories: categories,
          labels: {
            show: false
          },
        },
        markers: {
          enable:false,
          size: 4,
          colors: ["#098af7"],
          strokeColors: "#fff",
          strokeWidth: 2,
          hover: {
            size: 7
          }
        },
        yaxis: {
          tickAmount: 5,
          min: 0,
          max: 100,
          
        },
        fill: {
          type: "gradient",
          gradient: {
            type:"vertical",
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 50, 100],
            colorStops: [
              {
            offset: 0,
            color: "#01defe",
            opacity: 1
          },
          {
            offset: 20,
            color: "#1459f3",
            opacity: 1
          },
            ]
          }
        },
       }
        setMixedSeries(dataSetSeries)
        setMixedChartOptions(mixedSeriesOptions)
      }else{
        setMixedSeries([{name:'',type:'line',data:[]},{name:'',type:'column',data:[]}])
        setMixedChartOptions({
          chart: {
          id: "basic-bar",
          toolbar: {
            show: false
           }}
          })
      }
    console.log(JSON.stringify(tableData))
    var inprogress=tableData.filter(
      (v) => v.isCompleted === false
    ).length /
      tableData.length * 100
      if(isNaN(inprogress))
      setSeriesInprogress([0])
      else
      setSeriesInprogress([Math.round(inprogress,2)])

      var submitted=tableData.filter(
        (v) => v.isCompleted === true && v.comment === "In Approval"
      ).length /
        tableData.length * 100
        if(isNaN(submitted))
        setSeriesSubmitted([0])
        else
        setSeriesSubmitted([Math.round(submitted,2)])

        var approved=tableData.filter(
          (v) => v.comment === true
        ).length /
          tableData.length * 100
        if(isNaN(approved))
        setSeriesApproved([0])
        else
        setSeriesApproved([Math.round(approved,2)])

        
        var rejected=tableData.filter(
          (v) => 
          v.comment === false &&
          v.isCompleted === true
        ).length /
          tableData.length * 100
        if(isNaN(rejected))
        setSeriesRejected([0])
        else
        setSeriesRejected([Math.round(rejected,2)])
        
      //alert(inprogress)
    }
  })
  const onDialClicked=(dial)=>{
    if(dial=='InProgress')
    setTableFilterOption("<")
    if(dial=='Submitted')
    setTableFilterOption("=")
    if(dial=='Approved')
    setTableFilterOption("Approved")
    if(dial=='Rejected')
    setTableFilterOption("Rejected")
  }
  console.log(dateChart, "dateChart");
  // if(barChartData.length>0){
  //   barChartData.map(item=>{
  //     alert(item[0], "dateChart")
  //   })
  // }
  //rgb(48.800000000000004,165.60000000000002,204)
  const color1=`rgb(24,81,100)`;
  const color2=`rgb(10,7,24)`;
  //const rgb = [color1.substring(1,3), color1.substring(3,5), color1.substring(5,7)];
  //const color2 = `rgb(${rgb.map(c => (parseInt(c, 16) * 0.8)).join()})`;
  
  return <div className={classes.root}>
      <Grid container spacing={2} direction="row" justify="flex-start" alignItems="flex-start">
        <Grid item xs={12} sm={5} md={2}>
          <Card variant="outlined" style={{position:'relative', height: 260, backgroundColor: "white", boxShadow: " 0 1px 2px 0 rgba(1, 128, 141, 0.2), 0 1px 5px 0 rgba(1, 1, 141, 0.19)", borderRadius: "10px" }}>
            <Tooltip title={t("Shows Total Number of inspections, Sites on which inspections are conducted, different Templates being used, and auditors who conducted these inspections in the selected time period")}>
              <HelpOutlineIcon style={{ color: Colors.globalColor8, cursor: "pointer", position:'absolute', right:10, top:10 }} />
            </Tooltip>
            <CardContent>
              <Grid container spacing={0} direction="row"  justify="space-between"
                alignItems="center" className="cursor" onClick={handleAuditClick} style={{ marginTop: 10, display: "flex", justifyContent: "space-between" }}>
                <Grid item xs={6} sm={3} md={3}>
                  <img src={Audits} style={{ marginTop: 5 }} />
                </Grid>
                <Grid item xs={6} sm={6} md={6}>
                  <>
                    <div style={{ textAlign: "center", fontWeight: "bold", color: "#043077", //color: `linear-gradient(${50}deg,${color1}, ${color2})`,
                        fontSize: 22 }}>
                      {dataGlobal.audits}
                    </div>
                    <div style={{ textAlign: "center", fontWeight: "bold", fontSize: 12, marginTop: -5, color: "#19123e" }}>
                      {t("Inspections")}
                    </div>
                  </>
                </Grid>
              </Grid>
              <Grid container spacing={0} direction="row" justify="space-between"
                alignItems="center" className="cursor" onClick={handleLocationClick} style={{ display: "flex", }}>
                <Grid item xs={6} sm={6} md={3}>
                  <img src={Location} style={{ marginTop: 5 }} />
                </Grid>
                <Grid item xs={6} sm={6} md={6}>
                  <>
                    <div style={{ textAlign: "center", fontWeight: "bold", color: "#043077", fontSize: 22 }}>
                      {dataGlobal.location}
                    </div>
                    <div style={{ textAlign: "center", fontWeight: "bold", fontSize: 12, marginTop: -5, color: "#19123e" }}>
                      {t("Sites")}
                    </div>
                  </>
                </Grid>
              </Grid>
              <Grid container spacing={0} direction="row" justify="space-between"
                alignItems="center" className="cursor" onClick={handleNameClick} style={{ display: "flex", }}>
                <Grid item xs={6} sm={6} md={3}>
                  <img src={AuditNames} style={{ marginTop: 10 }} />
                </Grid>
                <Grid item xs={6} sm={6} md={6}>
                  <>
                    <div style={{ textAlign: "center", fontWeight: "bold", color: "#043077", fontSize: 22 }}>
                      {dataGlobal.audit_name}
                    </div>
                    <div style={{ textAlign: "center", fontWeight: "bold", fontSize: 12, marginTop: -5, color: "#19123e" }}>
                      {t("Templates")}
                    </div>
                  </>
                </Grid>
              </Grid>
              <Grid container spacing={0} direction="row" justify="space-between"        
                alignItems="center" className="cursor" onClick={handleAuditorClick} style={{ display: "flex", }}>
                <Grid item xs={6} sm={6} md={3}>
                  <img src={Auditor} style={{ marginTop: 10 }} />
                </Grid>
                <Grid item xs={6} sm={6} md={6}>
                  <>
                    <div style={{ textAlign: "center", fontWeight: "bold", color: "#043077", fontSize: 22 }}>
                      {dataGlobal.auditors}
                    </div>
                    <div style={{ textAlign: "center", fontWeight: "bold", fontSize: 12, marginTop: -5, color: "#19123e" }}>
                      {t("Inspectors")}
                    </div>
                  </>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={7} md={3}>
          <Card variant="outlined" style={{ height: 260, backgroundColor: "white", boxShadow: " 0 1px 2px 0 rgba(1, 128, 141, 0.2), 0 1px 5px 0 rgba(1, 1, 141, 0.19)", borderRadius: "10px" }}>
            <CardHeader classes={{ root: classes.header }} title={<div className={classes.title} style={{ display: "flex", flexDirection: "row",position:'relative', justifyContent: "center", alignItems: "center", margin: 5 }}>
                  <img src={statusIcon} />
                  <p className="filterHeading" style={{ marginLeft: "10px", color: "#306086", justifyContent: "left", display: "flex", fontSize: 14, fontWeight: "bold", marginTop: 0, marginBottom: 0 }}>
                    {t("Status & Filters")}
                  </p>
                  <Tooltip title={t("Shows percentage of inspections that are submitted, approved, rejected and in progress. Click on each to view inspection data in detail")}>
                        <HelpOutlineIcon style={{color:Colors.globalColor8, cursor:'pointer', position:'absolute', right:10 , top:0}} />
                    </Tooltip>
                </div>} />
            <CardContent style={{ padding: 6 }}>
              <Grid container spacing={1} direction="row" justify="center" alignItems="center">
                <Grid item lg={6} xs={6} sm={6} md={6}>
                  <div className="col radial-chart" onClick={() => {
                      onDialClicked("InProgress");
                    }} style={{ justifyContent: "center", display: "flex", maxHeight: 125, marginTop: -10, cursor: "pointer" }}>
                    <Chart options={radialOptionsInProgress} series={seriesInProgress} type="radialBar" width="205" />
                  </div>
                </Grid>

                <Grid item lg={6} xs={6} sm={6} md={6}>
                  <div className="col radial-chart" onClick={() => {
                      onDialClicked("Submitted");
                    }} style={{ justifyContent: "center", display: "flex", maxHeight: 125, marginTop: -10, cursor: "pointer" }}>
                    <Chart options={radialOptionsSubmitted} series={seriesSubmitted} type="radialBar" width="205" />
                  </div>
                </Grid>
              </Grid>
              <Grid container spacing={1} direction="row" justify="center" alignItems="center">
              
                <Grid item lg={6} xs={6} sm={6} md={6}>
                  <div className="col radial-chart" onClick={() => {
                      onDialClicked("Approved");
                    }} style={{ justifyContent: "center", display: "flex", maxHeight: 125, marginTop: -15, cursor: "pointer" }}>
                    <Chart options={radialOptionsApproved} series={seriesApproved} type="radialBar" width="205" />
                  </div>
                </Grid>
                <Grid item lg={6} xs={6} sm={6} md={6}>
                  <div className="col radial-chart" onClick={() => {
                      onDialClicked("Rejected");
                    }} style={{ justifyContent: "center", display: "flex", maxHeight: 125, marginTop: -15, cursor: "pointer" }}>
                    <Chart options={radialOptionsRejected} series={seriesRejected} type="radialBar" width="205" />
                  </div>
                </Grid>
              </Grid>
              {/* </Grid> */}
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={12} md={3}>
          <Card variant="outlined" style={{ height: 260, backgroundColor: "white", boxShadow: " 0 1px 2px 0 rgba(1, 128, 141, 0.2), 0 1px 5px 0 rgba(1, 1, 141, 0.19)", borderRadius: "10px" }}>
            <CardHeader classes={{ root: classes.header }} title={<>
                  <div className={classes.title} style={{position:"relative", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", marginTop: 5 }}>
                    <img src={searchIcon} />
                    <p className="filterHeading" style={{ marginLeft: "10px", color: "#306086", justifyContent: "left", display: "flex", fontSize: 14, fontWeight: "bold", marginTop: 0, marginBottom: 0 }}>
                      {t("Inspections")}
                    </p>
                    <Tooltip title={t("Represents total inspections conducted each day for the last seven days for a quick review")}>
                        <HelpOutlineIcon style={{color:Colors.globalColor8, cursor:'pointer', position:'absolute', right:10 , top:0}} />
                    </Tooltip>

                  </div>
                  <div style={{ paddingLeft: 18, fontSize: 12, marginBottom: 5, letterSpacing: 0, color: "#19123e", textAlign: "center" }}>
                    <b>{t("Last 07 Days, Daily")}</b>
                  </div>
                </>} />
            <CardContent style={{ paddingTop: 0, paddingBottom: 8 }}>
              <div className="col mixed-chart">
                <Chart options={lineOptions} series={lineSeries} type="line" />
              </div>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <Card variant="outlined" style={{ height: 260, overflowX: "auto", overflowY: "hidden", backgroundColor: "white", boxShadow: " 0 1px 2px 0 rgba(1, 128, 141, 0.2), 0 1px 5px 0 rgba(1, 1, 141, 0.19)", borderRadius: "10px" }}>
            <CardHeader classes={{ root: classes.header }} title={<>
                  <div style={{position:'relative',display:"flex", flexDirection: "row", justifyContent: "center", alignItems: "center", margin: 5 }}>
                    {/* <TimelineIcon style={{color:'#043077',fontSize:25}}/> */}
                    <img src={analysisIcon} />
                    <p className="filterHeading" style={{ marginLeft: "10px", color: "#306086", justifyContent: "left", display: "flex", fontSize: 14, fontWeight: "bold", marginTop: 0, marginBottom: 0 }}>
                      {t("Analysis")}
                    </p>
                    <Tooltip title={t("Analysis card is the representation of data given on the first card in the form of bar graph. User can click on each Number to see the change on analysis. By default “Inspections” data is plotted on the graph.")}>
                        <HelpOutlineIcon style={{color:Colors.globalColor8, cursor:'pointer', position:'absolute', right:10 , top:0}} />
                    </Tooltip>
                  </div>
                </>} />
            <CardContent>
              <div className="col mixed-chart" style={{ marginTop: -0 }}>
                <Chart options={mixedChartOptions} series={mixedSeries} type="line" height="190" />

              </div>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>;
};
